import { publishAnnouncementApi } from '@eastcoal/api/trade/announcementOperation/publishAnnouncement'

import { ConfirmButton } from '@eastcoal/common/components/Button/ConfirmButton'
import { useRemoteTableStore } from '@eastcoal/common/components/RemoteTable/Store/hooks/useStore'
import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { pick } from '@eastcoal/common/utils/object'

import { AnnouncementStatus } from '../../enums/AnnouncementStatus'

import { AnnouncementPublishDirectButtonProps } from './interface'

export const AnnouncementPublishDirectButton = ({
  uuid,
  record
}: AnnouncementPublishDirectButtonProps) => {
  const { message } = useFeedback()
  const { reload } = useRemoteTableStore(state => pick(state, ['reload']))

  const handleConfirm = async () => {
    await publishAnnouncementApi({
      id: record.id,
      status: AnnouncementStatus.PUBLISHED
    })
    message.success('直接发布成功')
    reload()
  }
  return record.status === AnnouncementStatus.SAVED ? (
    <ConfirmButton
      message='确定发布吗？'
      placement='leftBottom'
      type='link'
      uuid={uuid}
      onConfirm={handleConfirm}
    >
      直接发布
    </ConfirmButton>
  ) : null
}
